import { apiClient } from '../../../lib/api/client';

export interface BulkOperationListItem {
  id: string;
  operationType: string;
  purpose: string | null;
  status: string;
  initiatedByUserId: string;
  initiatedByEmail: string;
  initiatedAtUtc: string;
  completedAtUtc: string | null;
  revertedAtUtc: string | null;
  revertedByUserId: string | null;
  totalItems: number;
  successCount: number;
  failureCount: number;
  metadata: string | null;
}

export interface PagedBulkOperationsResponse {
  items: BulkOperationListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface RevertImportResponse {
  revertedCount: number;
}

export async function getBulkOperations(
  pageNumber: number,
  pageSize: number,
  operationType?: string,
): Promise<PagedBulkOperationsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));
  if (operationType) searchParams.set('operationType', operationType);
  const response = await apiClient.get<PagedBulkOperationsResponse>(
    `/bulk-operations?${searchParams.toString()}`,
  );
  return response.data;
}

export async function revertContactImport(bulkOperationId: string): Promise<RevertImportResponse> {
  const response = await apiClient.post<RevertImportResponse>('/contacts/import/revert', {
    bulkOperationId,
  });
  return response.data;
}

export async function exportContactsByBulkOperation(bulkOperationId: string): Promise<Blob> {
  const response = await apiClient.get<Blob>(
    `/contacts/import/${bulkOperationId}/export`,
    { responseType: 'blob' },
  );
  return response.data;
}

export interface RevertBulkFollowUpPayload {
  mode: 'all' | 'openOnly';
}

export async function revertBulkFollowUp(
  bulkOperationId: string,
  payload: RevertBulkFollowUpPayload
): Promise<{ revertedCount: number }> {
  const response = await apiClient.post<{ revertedCount: number }>(
    `/bulk-operations/${bulkOperationId}/revert-follow-up`,
    payload
  );
  return response.data;
}
